<template>
  <div class="table-row pinned-tab">
    <!-- <div class="report-side-panel bench-overview-side-panel q-box-shadow fromleft"> -->
    <div class="report-side-panel">
      <div class="sub-header">
        <!--- <report-header></report-header>-->
        <div class="date-range">
          <vue-monthly-picker :clearOption="false" v-model="dateIn" :monthLabels="monthLabels"></vue-monthly-picker>
          <div class="col position">
            <div class="select-wrapper" :class="projectClassObject">
              <v-select
                :options="projectsData"
                label="ProjectTitle"
                clear-button-icon="false"
                v-model="project"
              ></v-select>
            </div>
          </div>
          <div class="col position">
            <div class="select-wrapper" :class="employeeClassObject">
              <v-select
                :options="employeeData"
                label="EmployeeName"
                clear-button-icon="false"
                v-model="employee"
              ></v-select>
            </div>
          </div>
          <div class="download-button-wrapper">
            <a
              data-v-200367fa
              href
              class="cta-btn release-btn"
              @click.prevent="exportExcel()"
            >Download</a>
          </div>
          <!-- <i class="csv-export button-export" @click.stop="exportExcel()"></i> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueMonthlyPicker from "vue-monthly-picker"; //https://www.npmjs.com/package/vue-monthly-picker
import _ from "lodash";
import moment from "moment";

export default {
  name: "QtimeActivityRelation",
  data: () => {
    return {
      error: false,
      masterTableWidth: 0,
      loadMore: true,
      timeout: 0,
      dateIn: moment(),
      monthLabels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      searchError: {
        sap_no: false,
        employment: false
      },
      projectModel: null
    };
  },
  components: {
    VueMonthlyPicker
  },
  computed: {
    podioUser: function() {
      return this.$store.state.auth.podio_user;
    },
    filter: function() {
      return this.$store.state.qtimeReports.filter;
    },
    projectsData: function() {
      let projectsData = _.cloneDeep(this.$store.state.qtimeReports.projects);
      if (projectsData != null) {
        projectsData.push({ ItemId: 0, ProjectTitle: "Choose Project" });
      }
      // if(this.employeeData.find(x => x.ItemId === this.podioUser.itemId)!=null && this.$store.state.qtimeReports.filter.EmployeeId == 0)
      // {
      //   let employee = this.employeeData.find(x => x.ItemId === this.podioUser.itemId);
      //   this.employee= employee;
      // }
      // else if(this.$store.state.qtimeReports.filter.EmployeeId == 0)
      // {
      //   let employee = this.employeeData.find(x => x.ItemId === 0);
      //   this.employee= employee;
      // }
      return projectsData;
    },
    employeeData: function() {
      if (this.project) {
       
        let employeeData = _.cloneDeep(
          this.$store.state.qtimeReports.employees.filter(
            x => x.ProjectId === this.$store.state.qtimeReports.filter.ProjectId
          )
        );
        employeeData.push({ ItemId: 0, EmployeeName: "Choose Employee" });
        return employeeData;
          }
      return null;
    },
    project: {
      get: function() {
        let project = this.projectsData.find(
          x => x.ItemId === this.$store.state.qtimeReports.filter.ProjectId
        );
        if(project==undefined)
        {
            return project = this.projectsData.find(
            x => x.ItemId === 0
          );
        }
        return project;
        //return this.$store.state.qtime.filter.ProjectId;
      },
      set: function(value) {
        this.$store.commit("setFilterProjectId", value);
      }
    },
    employee: {
      get: function() {
          let employee = this.employeeData.find(
            x => x.ItemId === this.$store.state.qtimeReports.filter.EmployeeId
          );
          if(employee==undefined)
          {
            return employee = this.employeeData.find(
            x => x.ItemId === 0
          );
          }
          return employee;

        //return this.$store.state.qtime.filter.ProjectId;
      },
      set: function(value) {
        this.$store.commit("setFilterEmployeeId", value);
      }
    },
    projectClassObject: function() {
      return { "error-border": this.error };
    },
    employeeClassObject: function() {
      return { "error-border": this.error };
    }
  },
  beforeMount() {
    // let filter = _.cloneDeep(this.filter);
    // filter.ProjectId =0;
    // filter.EmployeeId =0;
    // filter.date = this.dateIn.format("MM-YYYY");
    // this.$store.dispatch("fetchQTimeActivity", filter);
     this.$store.commit("setActivityDateIn", this.dateIn.format("MM-YYYY"));
      let filter = _.cloneDeep(this.filter);
      filter.ProjectId =0;
      filter.EmployeeId =0;
      filter.date = this.dateIn.format("MM-YYYY");
      this.$store.dispatch("fetchQTimeActivity", filter);
  },
  methods: {
    fetchUpdatedReport: function() {
      // clone the current filter
      let filter = _.cloneDeep(this.filter);
      this.$store.dispatch("fetchQTimeActivity", filter);
    },
    exportExcel: function() {
      if (
        this.employee !== undefined &&
        this.project !== undefined &&
        this.employee.ItemId > 0 &&
        this.project.ItemId > 0
      ) {
        this.error = false;
        let filter = _.cloneDeep(this.filter);
        // send request
        this.$store.dispatch("exportActivityReport", filter);
      } else {
        this.error = true;
      }
    }
  },
  updated() {},
  mounted() {},

  destroyed() {},
  watch: {
    dateIn: function() {
      this.$store.commit("setActivityDateIn", this.dateIn.format("MM-YYYY"));
      let filter = _.cloneDeep(this.filter);
      filter.ProjectId =0;
      filter.EmployeeId =0;
      filter.date = this.dateIn.format("MM-YYYY");
      this.$store.dispatch("fetchQTimeActivity", filter);
      //this.fetchUpdatedReport();
    },
    employeeData: {
      handler: function(val) {
        if(val.find(x => x.ItemId === this.podioUser.itemId)!=null && this.employee.ItemId == 0)
        {
            let employee = val.find(x => x.ItemId === this.podioUser.itemId);
            this.employee= employee;
        }
      },
      deep: true,
      immediate: true
    } 
  }
};
</script>
<style scoped>
.error-border {
  border: 1px solid red;
}

.table-row {
  padding: 20px 20px 10px 20px;
  background: none;
  border: 1px solid rgba(192, 192, 192, 0.3411764705882353);
  border-radius: 11px;
}

.qtime-activity-view {
  width: 100%;
}

.table-row .position {
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 10px;
}

.month-year-label {
  margin-bottom: 10px;
}

.download-button-wrapper {
  width: 100%;
  text-align: center;
}

.cta-btn {
  padding: 7px 19px;
  margin: 0 auto;
}


.sub-header .date-range,
.sub-header{
  border-top: none !important;
  border-bottom: none !important;
}

.table-row{
  height: 206px;
}



@media screen and (max-width: 1573px){
  .sub-header .date-range{
      padding-left: 0;
      }
}
</style>